var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"account",class:{
    active:
      (_vm.isDiaspora && _vm.getAccountType === _vm.label) ||
      (_vm.isStartup && _vm.getAccountType === _vm.label),
  },attrs:{"type":"button"},on:{"click":_vm.commitAccountType}},[_c('div',{staticClass:"profile-container"},[_c('img',{attrs:{"src":_vm.profileImg}})]),_c('div',{staticClass:"account-label"},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }